import React, { useEffect, useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import "./Contact.css";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const navigate = useNavigate()
  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark' ||
      (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches);
  });

  // Apply dark/light mode
  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };
  return (
    <>
      <header className="top-header">
        <div className="header-left">
          <div className="date-time">
            <span className="date">{new Date().toLocaleDateString('ta-IN')}</span>
            <span className="time">{new Date().toLocaleTimeString('ta-IN', { hour: '2-digit', minute: '2-digit' })}</span>
          </div>
        </div>

        <div className="logo-container">
          <img
            src="/assets/unnamed1.png"
            alt="Lookit"
            className="main-logo"
            onClick={() => { navigate("/") }}
            style={{ cursor: "pointer" }}
            onError={(e) => {
              e.target.src = "/assets/unnamed1.png";
            }}
          />
        </div>

        <div className="header-right">
          <button className="theme-toggle" onClick={toggleDarkMode}>
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </div>
      </header>
      <div className="page-container">
        <div className="containerfourcnt">
          <div className="page-herocnt">
            <h1>Contact Us</h1>
            <p>We'd love to hear from you</p>
          </div>

          <div className="contact-contentcnt">
            <div className="contact-infocnt">
              <h2>Get in Touch</h2>
              <div className="contact-itemcnt">
                <h3>Email</h3>
                <p>hr@mpeoples.in</p>
              </div>

              <div className="contact-itemcnt">
                <h3>Phone</h3>
                <p>8508508590</p>
              </div>

              <div className="contact-itemcnt">
                <h3>Follow Us</h3>
                <div className="social-linksfour">
                  <a href="https://www.facebook.com/share/1Cfuh8mwVH/" className="social-linkfour"> <FaFacebookF /> </a>
                  <a href="https://www.instagram.com/readers_menu?igsh=bml4emczZXU5ZXV6" className="social-linkfour"> <FaInstagram /> </a>
                  <a href="https://youtube.com/@readers_menu?si=uUI_8NeVUYGtRune" className="social-linkfour"> <FaYoutube /> </a>
                </div>
              </div>

              <div className="contact-itemcnt">
                <h3>Location</h3>
                <p>MPeoples Business Solutions Pvt Ltd,
                  No 56/3-1 Ranga Nagar, 3rd Cross Street,
                  Suramangalam, Salem-636005.</p>
              </div>
            </div>

            <div className="map-containercnt">
              <h2>Find Us</h2>
              <div className="map-placeholdercnt">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d430.6588223847722!2d78.11677405580136!3d11.668319830943071!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x401bdcb2d3c2cf55%3A0x2f3ca69cc4d4258c!2sMPeoples%20Business%20Solutions%20Pvt.%20Ltd.%2C!5e0!3m2!1sen!2sin!4v1758369433791!5m2!1sen!2sin" style={{ border: "0" }} loading="lazy" ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;